"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollGuestExperienceCategory = void 0;
/**
 * A choice category used for defining guest experience. This caregory is used only for guest surveys and should NOT be used for anything else.
 * @export
 * @enum {string}
 */
exports.PollGuestExperienceCategory = {
    Stress: 'stress',
    Anxiety: 'anxiety',
    Depression: 'depression',
    WeightLoss: 'weight_loss',
};
//# sourceMappingURL=poll-guest-experience-category.js.map